import React from 'react';
import {MasterLayout} from 'components/layouts';
import {
  HomeBanner,
  HighlightBusinessesContainer,
  FavoriteCategoryContainer,
  HighlightProductByCategoryContainer,
  TradeNewsContainer,
  EasyNeedOfferContainer,
  NeedOffersByCategoryContainer,
  SupportInfoContainer,
  NewsLetterRegister,
  HotProducts,
  ProductsByCategory,
  HighlightProductByCategoryContainerOCOOP
} from './sub-view';
import {withRouter} from 'react-router';
import title from 'constants/TitlePages.js';

import { asyncConnect } from 'redux-connect';
import CONFIG from 'base/constants/config';

@asyncConnect([{
  key: 'nokey',
  promise: ({ match: { params }, store: { dispatch }, helpers }) => {
    dispatch({
      type: 'SEO_INFO',
      data: {
        title: title.Home,
        description: 'Sàn giao dịch thương mại điện tử tỉnh Đắk Lắk – DaklakTrade là một thị trường trực tuyến, một địa điểm họp chợ online được thực hiện trên mạng internet giữa người bán và người mua, ở đó những người tham gia có thể tự mình tìm kiếm thông tin về thị trường và sản phẩm – dịch vụ, thiết lập mối quan hệ cũng như tiến hành đàm phán trong từng giao dịch.',
        image: `${CONFIG.UploadImageURL}/03708aed6ad48b41b843785cf1d0d3de.jpg`
      }
    });
  }
}])
class Home extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.Home;
    setTimeout(() => { window.dispatchEvent(new Event('resize')); }, 150);
  }

  render() {
    return (
      <MasterLayout>
        <HomeBanner/>
        <HighlightProductByCategoryContainer/>
        <HighlightProductByCategoryContainerOCOOP/>
        <div className='center'>
          <div className='wrap-category-list'>
            <ProductsByCategory categoryID='59f1f7fccc2c260ce26843f1' subCategoryID='5a24b6bb7b9f190ffea3cc10' categoryTitle="Nông - lâm - Thủy sản" imageCategory={require('assets/images/icon-colorful/Hang_Dac_San.svg')}/>
            <ProductsByCategory categoryID='59f1f8bbcc2c260ce26843f7' subCategoryID='5a24b5b77b9f190ffea3cbfa' categoryTitle="Thực phẩm chế biến" imageCategory={require('assets/images/category-1.jpg')}/>
          </div>
        </div>
        <HighlightBusinessesContainer/>
        <HotProducts/>
        <SupportInfoContainer/>
      </MasterLayout>
    );
  }
}

export default withRouter(Home);



// WEBPACK FOOTER //
// ./components/home/Home.jsx